import setupMobileMenu from "../components/SetupMobileMenu";
import setupStickyHeader from "../components/SetupStickyHeader";
import setupAnimateIn from "../components/SetupAnimateIn";
import setupLoadMorePosts from "../components/SetupLoadMorePosts";
import setupShowCallUsModal from "../components/SetupShowCallModal";
import setupHeaderSearch from "../components/SetupHeaderSearch";

export default {
  init() {
    setupStickyHeader();
    setupAnimateIn();
    setupMobileMenu();
    setupLoadMorePosts();
    setupShowCallUsModal();
    setupHeaderSearch();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
